import { EffectCallback, useEffect } from 'react';

/** This only exists to hide eslint warnings from useEffects with empty dependency arrays */
// eslint-disable-next-line react-hooks/exhaustive-deps
const useMountEffect = (effect: EffectCallback) => useEffect(effect, []);
export default useMountEffect;
